import styled from 'styled-components';

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 22px;
  .row {
    display: flex;
    flex-direction: row;
    gap: 14px;
  }
`;

export const DownloadButton = styled.button`
  border-radius: 4px;
  border: none;
  color: #909090;
  font-weight: 900;
  font-size: 16px;
  cursor: pointer;
  padding: 10px 16px;
  background-color: ${props => (props.isActive ? '#008CFF' : '#C2C2C2')};
  color: ${props => (props.isActive ? '#fff' : '#909090')};
  box-shadow: ${props => (props.isActive ? '0px 1px 7px rgba(0, 0, 0, 0.21)' : '')};
`;
